export const identifyIcon = (description) => {
  const arr = description.split(" ");
  const icon = arr[arr.length - 1];
  return icon;
};

export default identifyIcon;
